module.exports = __webpack_public_path__ + "img/WESicon4.d0998a3e.png";